import { useEffect } from "react";
import { useNavigate } from "react-router";

export default function NotFound() {
    const navigate = useNavigate();

    useEffect(() => {
        // Redirect to home after 2 seconds
        const timer = setTimeout(() => {
            navigate("/");
        }, 2000);

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 text-center px-4">
            <h1 className="text-6xl font-bold text-gray-800">404</h1>
            <p className="text-xl text-gray-600 mt-4">
                Oops! The page you are looking for doesn’t exist.
            </p>
            <p className="text-gray-500 mt-2">
                Redirecting you to the home page…
            </p>

            <button
                onClick={() => navigate("/")}
                className="mt-6 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
            >
                Go to Home
            </button>
        </div>
    );
}
